import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAvailabilityStatus } from '../../containers/App/actions';

class Nav extends Component {
  state = {
    mobileClassName: 'navbar-menu',
    mobileNavCollapsed: false,
  }

  toggleNav = (value) => {
    if (value) {
      this.setState({
        mobileClassName: 'navbar-menu',
        mobileNavCollapsed: false,
      });
    } else {
      this.setState({
        mobileClassName: 'navbar-menu is-active',
        mobileNavCollapsed: true,
      });
    }
  }

  render() {
    const { history, isAvailable, submitting, user, setOnlineStatus, logout } = this.props;
    return (
      <nav className='navbar is-fixed-top' role='navigation' aria-label='main navigation'>
        <div className='container'>
          <div className='navbar-brand'>
            <span className='navbar-item'>
              <h3 className='title is-4 pointer logo' onClick={() => history.push('/')}>
                cloudchefs
              </h3>
            </span>
          </div>
          <div className='navbar-end'>
            {user && (user.firstName || user.email) && (
              <div className='navbar-item has-text-grey'>
                {user.firstName ? `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}` : user.email}
              </div>
            )}
            <div className='navbar-item'>
              {isAvailable
                ? <button
                    onClick={() => setOnlineStatus(false, user && user.idToken, user && user.id)}
                    className={`button is-light ${submitting ? 'is-loading' : ''}`}
                    disabled={submitting}
                  >
                    Go Offline
                  </button>
                : <button
                    onClick={() => setOnlineStatus(true, user && user.idToken, user && user.id)}
                    className={`button is-primary ${submitting ? 'is-loading' : ''}`}
                    disabled={submitting}
                  >
                    Go Online
                  </button>}
            </div>
            {logout && <div className='navbar-item'>
              <button onClick={logout} className='button is-light'>
                Sign Out
              </button>
            </div>}
          </div>
        </div>
      </nav>
    )
  }
}

const mapStateToProps = state => ({
  isAvailable: state.app.isAvailable,
  submitting: state.app.submitting,
  user: state.auth && state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  setOnlineStatus: (isAvailable, idToken, id) => dispatch(setAvailabilityStatus(isAvailable, idToken, id))
});

Nav = connect(mapStateToProps, mapDispatchToProps)(Nav);

export default withRouter(Nav);
